import Masonry 			from 'masonry-layout';
import ImagesLoaded from 'imagesloaded';
import hasclass 		from 'javascripts/modules/util.hasclass';

class WallGrid {

	constructor(element){
		this.masonryInstance = null;
		this.masonryWrapper  = hasclass(element, 'wall-grid') ? element : element.querySelector('.wall-grid');
		this._init();
	}

	_init(){
		
		this.masonryInstance = new Masonry( this.masonryWrapper, {
		 	itemSelector: '.wall-grid__item'
		});

		this._imageLoadProgress();

	}

	_imageLoadProgress(){
		const imgLoad = ImagesLoaded( this.masonryWrapper );
		imgLoad.on( 'progress', ( instance, image ) => this.reBuild() );
	}

  reBuild(){
    this.masonryInstance.layout();
  }

  reLoad(){
    this.masonryInstance.reloadItems();
    this.masonryInstance.layout();
  }

}

export default WallGrid;


